/* eslint-disable react/no-unknown-property */
/* eslint-disable max-len */
import React from 'react';

/**
 * WarningIcon - Auto-generated from icon.js
 */
export const WarningIcon = (props: React.SVGProps<SVGSVGElement>): JSX.Element => (
	<svg width="33" height="32" viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<g clipPath="url(#clip0_2383_1822)">
			<path fillRule="evenodd" clipRule="evenodd" d="M16.5 1.90735e-06C7.6625 1.90735e-06 0.5 7.1625 0.5 16C0.5 24.8375 7.6625 32 16.5 32C25.3375 32 32.5 24.8375 32.5 16C32.5 7.1625 25.3375 1.90735e-06 16.5 1.90735e-06ZM17.5 25C17.5 25.5531 17.0531 26 16.5 26C15.9469 26 15.5 25.5531 15.5 25C15.5 24.4469 15.9469 24 16.5 24C17.0531 24 17.5 24.4469 17.5 25ZM17.5 21C17.5 21.5531 17.0531 22 16.5 22C15.9469 22 15.5 21.5531 15.5 21V7C15.5 6.44687 15.9469 6 16.5 6C17.0531 6 17.5 6.44687 17.5 7V21Z" fill="#FA8B00" />
		</g>
		<defs>
			<clipPath id="clip0_2383_1822">
				<rect width="32" height="32" fill="white" transform="translate(0.5)" />
			</clipPath>
		</defs>
	</svg>
);

export default WarningIcon;
